import { Flex } from "@chakra-ui/react";
import React from "react";
import AddIndividual from "./components/AddIndividual";

function Data() {


  return (
    <Flex direction="column" pt={{ base: "62px", md: "75px", xl: "88px" }}>
      <AddIndividual
      />
    </Flex>
  );
}

export default Data;
